import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http'
import {environment} from '@environments/environment';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class WalletService {


  constructor(private http: HttpClient) {
  }

  getDashboardInfo(): Observable<any> {
    return this.http.get(environment.WALLET_API_URL + '/v1/statistics')
  }

  getBadgers(): Observable<any> {
    return this.http.get(environment.WALLET_API_URL + '/v1/statistics/badgers')
  }

  getWallets(): Observable<any> {
    return this.http.get(environment.WALLET_API_URL + '/v1/wallet');
  }

  availableBanks() {
    return this.http.get(environment.WALLET_API_URL + '/v1/bank-account/available-banks');
  }

  addBankAccount(payload: any) {
    return this.http.post(environment.WALLET_API_URL + '/v1/bank-account', payload)
  }

  getBankAccounts(pageSize: number, currentPage: number): Observable<any> {
    return this.http.get(environment.WALLET_API_URL + `/v1/bank-account?size=${pageSize}&page=${currentPage}`);
  }

  removeBankAccount(bankAccountId: number): Observable<any> {
    return this.http.delete(environment.WALLET_API_URL + `/v1/bank-account/${bankAccountId}`)
  }

  availableStablecoins() {
    return this.http.get(environment.WALLET_API_URL + '/v1/stablecoin-wallet/available-stablecoins');
  }

  availableStablecoinChains() {
    return this.http.get(environment.WALLET_API_URL + '/v1/stablecoin-wallet/available-stablecoin-chains');
  }

  addStablecoinWallet(payload: any) {
    return this.http.post(environment.WALLET_API_URL + '/v1/stablecoin-wallet', payload)
  }

  getStablecoinWallets(pageSize: number, currentPage: number): Observable<any> {
    return this.http.get(environment.WALLET_API_URL + `/v1/stablecoin-wallet?size=${pageSize}&page=${currentPage}`);
  }

  removeStablecoinWallet(id: number): Observable<any> {
    return this.http.delete(environment.WALLET_API_URL + `/v1/stablecoin-wallet/${id}`)
  }

}
